import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {createConference} from 'src/openapi/admin/apis/ConferenceApi';
import {CreateConferenceResponse} from 'src/openapi/admin/models/CreateConferenceResponse';
import {useAppDispatch} from 'src/store/hooks';

import type {CreateConferenceRequest} from 'src/openapi/admin/models/CreateConferenceRequest';

type Props = {
    accountId: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useCreateConferenceForAccount = ({accountId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((createConferenceRequest: CreateConferenceRequest) => (
        apiDispatch(createConference({accountId, createConferenceRequest}))
    ), [accountId, apiDispatch]);

    return useCommonEventHook<CreateConferenceRequest, CreateConferenceResponse>({
        eventAction,
        onSuccess,
        onFail,
    });
};
